import React, { useEffect, useState } from 'react';
import DropDown from './components/DropDown/DropDown';
import DescriptionContainer from './components/descriptionContainer';
import { ListingPromise } from './utils/retrieveS3';
import store from './store/store';
import { populateData } from './store/slices/modelSurfaceSlice';
import ModelSurfaceTable from './components/table/ModelSurfaceTable';
import { surveys } from './store/slices/modelSurfaceSlice';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

export const App = () => {
  const data = useSelector(surveys);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ListingPromise.then((res) => {
      store.dispatch(populateData(res));
    });
  }, []);

  useEffect(() => {
    if (data.length) {
      setLoading(false);
    }
  }, [data]);

  return (
    <div>
      <DescriptionContainer />
      {loading ? (
        <span style={{ textAlign: 'center', display: 'block' }}>
          <CircularProgress />
        </span>
      ) : (
        <>
          {' '}
          <DropDown />
          <ModelSurfaceTable />
        </>
      )}
    </div>
  );
};
